module.exports = __webpack_public_path__ + "static/testimonials-67e467040c29f83c943d161ddb3d9c46.jpg";